export default __webpack_public_path__ + "static/media/bandeira.fdaabc6b.png";